import {ajaxActions} from "../AjaxActions";

const BASE_URL = process.env.REACT_APP_SHARE_SERVICE_URL;

export const fetchContract = (contractId) => ajaxActions.get(BASE_URL + "/contracts/" + contractId).then(resp => {
    return resp;
});

export const withdrawContract = (contractId, reasonOfWithDrawning) => ajaxActions.patch(BASE_URL + "/contracts/withdraw?contractId=" + encodeURIComponent(contractId), reasonOfWithDrawning || undefined).then(resp => {
    return resp;
});

export const fetchDocument = (documentId) => ajaxActions.get(BASE_URL + "/documents/" + documentId).then(resp => {
    return resp;
});

export const patchDocument = (documentId, patch) => ajaxActions.patch(BASE_URL + "/documents/" + documentId, patch).then(resp => {
    return resp;
});

export const patchDocumentPosition = (documentId, positionId, patch) => ajaxActions.patch(BASE_URL + "/documents/" + documentId + "/positions/" + positionId, patch).then(resp => {
    return resp;
});

export const fetchQuestionnaire = (questionnaireId) => ajaxActions.get(BASE_URL + "/questionnaires/" + questionnaireId).then(resp => {
    return resp;
});
